import { sortCommentsAscending } from "components/common/comments/sortComments";
import { cloneDeep } from "lodash";
import { applyPatch } from "rfc6902";
import { HierarchyContextProps, IHierarchyActionPatchHierarchyComments } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Applies an RFC6902 patch to the current hierarchy comment list.
 *
 * @param state - The current hierarchy context state.
 * @param action - The patch-hierarchy-comments action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_patchHierarchyComments = (
  state: HierarchyContextProps,
  action: IHierarchyActionPatchHierarchyComments,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const commentsPatch = action.patch;
  /* istanbul ignore else */
  if (commentsPatch.length > 0) {
    const newComments = cloneDeep(state.hierarchy.comments).sort(sortCommentsAscending);
    applyPatch(newComments, commentsPatch);

    return hcr_updateChangedFlag(
      {
        ...state,
        hierarchy: {
          ...state.hierarchy,
          comments: newComments,
        },
      },
      action,
    );
  }

  return state;
};
